import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const ExpandableItemsList = t0 => {
  const $ = _c(11);
  const {
    children,
    initialNumberToShow: t1
  } = t0;
  const initialNumberToShow = t1 === undefined ? 7 : t1;
  const [isOpen, setIsOpen] = useState(false);
  let isExpandable;
  let t2;
  if ($[0] !== children || $[1] !== initialNumberToShow || $[2] !== isOpen) {
    const childArray = React.Children.toArray(children);
    const totalNumberOfItems = childArray.length;
    isExpandable = totalNumberOfItems > initialNumberToShow;
    t2 = isExpandable && !isOpen ? childArray.slice(0, initialNumberToShow) : childArray;
    $[0] = children;
    $[1] = initialNumberToShow;
    $[2] = isOpen;
    $[3] = isExpandable;
    $[4] = t2;
  } else {
    isExpandable = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isExpandable || $[6] !== isOpen) {
    t3 = isExpandable && <button type="button" onClick={() => {
      setIsOpen(!isOpen);
    }} className="text-base text-gray mt-2 hover:text-gray-dark">{!isOpen ? "+ More" : "- Less"}</button>;
    $[5] = isExpandable;
    $[6] = isOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
ExpandableItemsList.propTypes = {
  children: PropTypes.node,
  initialNumberToShow: PropTypes.number
};
export default ExpandableItemsList;